import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  PocketRefComponent,
  GuidenoteDisplayDialog,
} from "./pocket-ref/pocket-ref.component";
import { FormsModule } from "@angular/forms";

import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTreeModule } from "@angular/material/tree";
import { MatProgressBarModule as MatProgressBarModule } from "@angular/material/progress-bar";
import { MatCheckboxModule as MatCheckboxModule } from "@angular/material/checkbox";
import { MatTooltipModule as MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule as MatDialogModule } from "@angular/material/dialog";
import { MatInputModule as MatInputModule } from "@angular/material/input";
import { MatSelectModule as MatSelectModule } from "@angular/material/select";
import { DragDropModule } from "@angular/cdk/drag-drop";

@NgModule({
  declarations: [PocketRefComponent, GuidenoteDisplayDialog],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTreeModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    DragDropModule,
  ],
})
export class PocketRefModule {}
